module.exports = __webpack_public_path__ + "static/media/dunaital.b3016597.png";